import React from 'react'
import AlternatingTableRow from '../table/AlternatingTableRow'
import StandardTableCell from '../table/StandardTableCell'
import { hasRole, User } from '../models/User'
import { RoleType } from '../models/Role'
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TransparentIconButton from '../common/TransparentIconButton'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

type Props = {
    user: User;
    index: number;
    onGrantAdmin: () => void;
    onDelete: () => void;
}

const UserRoleRow = ({ user, index, onGrantAdmin, onDelete }: Props) => {
    return (
        <AlternatingTableRow index={index}>
            <StandardTableCell align="left">{user.email}</StandardTableCell>
            <StandardTableCell
                className="w-[60px]"
                align="center"
            >
                {hasRole(user, RoleType.OWNER) && (
                    <span>
                        <CheckCircleIcon className="text-status-success" />
                    </span>
                )}
                {!hasRole(user, RoleType.OWNER) && (
                    <TransparentIconButton onClick={() => onGrantAdmin()}>
                        <AddModeratorIcon className="text-primary" />
                    </TransparentIconButton>
                )}
            </StandardTableCell>
            <StandardTableCell
                className="w-[60px] h-[49px]"
                align="center"
            >
                {!hasRole(user, RoleType.OWNER) && (
                    <TransparentIconButton onClick={() => onDelete()}>
                        <DeleteForeverIcon className="text-error" />
                    </TransparentIconButton>
                )}
            </StandardTableCell>
        </AlternatingTableRow>
    )
}

export default UserRoleRow